"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textPropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const as = ['span', 'div', 'label', 'p'];
const sizes = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
const textPropDefs = {
    as: { type: 'enum', values: as, default: 'span' },
    asChild: index_js_1.asChildProp,
    size: {
        type: 'enum',
        className: 'rt-r-size',
        values: sizes,
        default: undefined,
        responsive: true,
    },
    weight: index_js_1.weightProp,
    align: index_js_1.alignProp,
    trim: index_js_1.trimProp,
    truncate: index_js_1.truncateProp,
    wrap: index_js_1.textWrapProp,
    color: index_js_1.inheritedColorProp,
    highContrast: index_js_1.highContrastProp,
};
exports.textPropDefs = textPropDefs;
//# sourceMappingURL=text.props.js.map